(function () {
  var STYLE_ID = 'vasq-share-styles';
  if (!document.getElementById(STYLE_ID)) {
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.vasq-share-wrap{position:absolute;top:10px;right:10px;z-index:5;}',
      '.vasq-share-btn{width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,0.9);border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,0.2);padding:0;}',
      '.vasq-share-btn svg{width:16px;height:16px;}',
      '.vasq-share-menu{position:absolute;top:36px;right:0;background:#fff;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,0.18);min-width:180px;padding:6px;display:none;flex-direction:column;gap:2px;}',
      '.vasq-share-menu.open{display:flex;}',
      '.vasq-share-menu button{display:flex;align-items:center;gap:10px;background:none;border:none;text-align:left;padding:8px 10px;border-radius:6px;cursor:pointer;font-size:13px;color:#1a1a1a;font-family:inherit;}',
      '.vasq-share-menu button:hover{background:#f2f2f2;}',
      '.vasq-share-menu button svg{width:16px;height:16px;flex-shrink:0;}',
      '.vasq-share-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#0d0d0d;color:#f8f7f3;padding:10px 18px;border-radius:20px;font-size:13px;z-index:9999;opacity:0;transition:opacity .2s;pointer-events:none;}',
      '.vasq-share-toast.show{opacity:1;}'
    ].join('');
    document.head.appendChild(style);
  }

  var ICONS = {
    dots: '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>',
    whatsapp: '<svg viewBox="0 0 24 24" fill="#25D366"><path d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.36 5.07L2 22l5.06-1.32A9.94 9.94 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.6 0-3.09-.47-4.34-1.28l-.31-.19-3 .78.8-2.92-.2-.3A7.94 7.94 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8z"/></svg>',
    facebook: '<svg viewBox="0 0 24 24" fill="#1877F2"><path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0 0 22 12z"/></svg>',
    instagram: '<svg viewBox="0 0 24 24" fill="none" stroke="url(#ig-grad)" stroke-width="2"><defs><linearGradient id="ig-grad" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#f9ce34"/><stop offset="50%" stop-color="#ee2a7b"/><stop offset="100%" stop-color="#6228d7"/></linearGradient></defs><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="#ee2a7b" stroke="none"/></svg>'
  };

  function showToast(msg) {
    var toast = document.querySelector('.vasq-share-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'vasq-share-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  function copyLink(url) {
    navigator.clipboard.writeText(url).then(function () {
      showToast('Link copied!');
    }).catch(function () {
      showToast('Could not copy link');
    });
  }

  function closeAllMenus() {
    document.querySelectorAll('.vasq-share-menu.open').forEach(function (m) {
      m.classList.remove('open');
    });
  }

  function buildMenu(url, title) {
    var menu = document.createElement('div');
    menu.className = 'vasq-share-menu';

    var items = [
      { icon: ICONS.copy, label: 'Copy link', action: function () { copyLink(url); } },
      { icon: ICONS.whatsapp, label: 'WhatsApp', action: function () { window.open('https://api.whatsapp.com/send?text=' + encodeURIComponent(title + ' ' + url), '_blank'); } },
      { icon: ICONS.facebook, label: 'Facebook', action: function () { window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank', 'width=600,height=400'); } },
      { icon: ICONS.instagram, label: 'Instagram', action: function () { copyLink(url); showToast('Link copied! Paste it in your Instagram bio, DM, or story.'); } }
    ];

    items.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.innerHTML = item.icon + '<span>' + item.label + '</span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        item.action();
        closeAllMenus();
      });
      menu.appendChild(btn);
    });

    return menu;
  }

  function attachShareButton(container, url, title) {
    if (container.querySelector('.vasq-share-wrap')) return;
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    var wrap = document.createElement('div');
    wrap.className = 'vasq-share-wrap';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vasq-share-btn';
    btn.setAttribute('aria-label', 'Share this product');
    btn.innerHTML = ICONS.dots;

    var menu = buildMenu(url, title);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = menu.classList.contains('open');
      closeAllMenus();
      if (!isOpen) menu.classList.add('open');
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);
    container.appendChild(wrap);
  }

  function init() {
    // Product cards in collection/grid views
    document.querySelectorAll('.card-wrapper, .card, [class*="card-product"]').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var mediaContainer = card.querySelector('.card__media, .media, [class*="card__inner"]') || card;
      var url = new URL(link.getAttribute('href'), window.location.origin).href;
      var title = (card.querySelector('.card__heading, [class*="title"]') || {}).textContent || document.title;
      attachShareButton(mediaContainer, url, title.trim());
    });

    // Main product page gallery
    var mainMedia = document.querySelector('.product__media-list, [class*="product-media-container"], .product__media-wrapper');
    if (mainMedia) {
      attachShareButton(mainMedia, window.location.href, document.title);
    }
  }

  document.addEventListener('click', closeAllMenus);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();

  // Re-scan periodically for lazy-loaded / dynamically swapped product grids
  var observer = new MutationObserver(function () {
    clearTimeout(window.__vasqShareTimer);
    window.__vasqShareTimer = setTimeout(init, 400);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
